import { parseApiError } from './apiError';

export const loginWithAppleIdToken = async (idToken: string) => {
  const res = await fetch(`${process.env.REACT_APP_API_URL}api/auth/apple/web`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ idToken })
  });
  if (!res.ok) throw await parseApiError(res, 'Connexion Apple impossible');
  return res.json();
};
